import {
	mess,
	canteen,
	sports,
	laundry,
	jbclub,
	hero,
	GYM,
	diet1,
	restaurant1,
	sports1,
	laundryMachine1,
	snooker1,
	accomodation1,
	weights1,
} from "../../assets/card";

const data = [
	{
		name: "Mess",
		description:
			"Jawahar Bhawan’s mess provides students with nutritious food daily. With its focus on quality and cleanliness, it is one of the best places to eat your food at. With the mess of accepting online payments, it is now quite convenient for the students to buy coupons for those special occasions where they feel like indulging themselves. Moreover, the mess also allows visitors so you can eat with your parents as well. 24*7 ",
		flexDirection: "row",
		vector: diet1,
		img: mess,
	},

	{
		name: "Canteens",
		description:
			"Jawahar Bhawan is a place where you can eat what you desire. With two canteens opening alternatively in day and night, you have a variety of choices to choose from which include but are not limited to Maggi, spring rolls, chowmein, poha, tea, coffee, cold drinks, etc. With the prices being fixed by the chief warden you won't need to worry about your budget while you enjoy the appetizing dishes.",
		flexDirection: "row-reverse",
		vector: restaurant1,
		img: canteen,
	},

	{
		name: "Sports Facilities",
		description:
			"At Jawahar Bhawan, we have excellent sports facilities available for all. With highly maintained badminton courts and sufficient space for playing outdoor sports you won't ever feel the need to go somewhere else to play.",
		flexDirection: "row",
		vector: sports1,
		img: sports,
	},

	{
		name: "Washing Room",
		description:
			"Focusing on making the students fully independent adults, Jawahar Bhawan provides them with a laundry room, with an optimum number of fully automatic washing machines installed. We also have a paid washerman in the bhawan who comes on two days in Bhawan i.e.Wednesday and Sunday.",
		flexDirection: "row-reverse",
		vector: laundryMachine1,
		img: laundry,
	},

	{
		name: "Jawahar Club",
		description:
			"Jawahar Bhawan boasts its club - Jawahar Club - an alternative to those who find going to the student’s club tiresome. With the only bhawan to have its own club with billiards and pool tables, it is one of the best places for students to wind down after a hectic day. It also has facilities for foosball, table tennis, carrom, chess and much more.",
		flexDirection: "row",
		vector: snooker1,
		img: jbclub,
	},

	{
		name: "Guest Room",
		description:
			"With guest rooms available at demand, you will not be needed to undergo the lengthy booking procedures of any hotel. Moreover, it's helpful in cases when you forget to book a hotel after all we know how busy a student’s life is; academics, clubs",
		flexDirection: "row-reverse",
		vector: accomodation1,
		img: hero,
	},

	{
		name: "Gymnasium",
		description:
			"Fitness freak? We got you covered. With the gym open for all students, you get access to all the equipment that is also regularly maintained. Hence, continue on your body-building journey or maybe start on one.",
		flexDirection: "row",
		vector: weights1,
		img: GYM,
	},
];

export default data;
